import AlternateEmailOutlinedIcon from '@mui/icons-material/AlternateEmailOutlined';
import EmailIcon from '@mui/icons-material/Email';
import LogoutIcon from '@mui/icons-material/Logout';
import PersonIcon from '@mui/icons-material/Person';
import {ClickAwayListener} from '@mui/material';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import type {SxProps} from '@mui/system';
import {lighten} from '@mui/system/colorManipulator';
import type {FC} from 'react';
import {useTranslation} from 'react-i18next';
import LabelChip from '@/components/common/LabelChip';
import type {User} from '@/domain/entities/User';
import {primaryColor} from '@/theme/theme';

//TYPES
type Props = {
  isOpen: boolean;
  user: User;
  onLogout: () => void;
  onClose: () => void;
};

const ProfilePanel: FC<Props> = ({isOpen, user, onLogout, onClose}) => {
  const {t} = useTranslation();

  const {username, email, firstName, lastName, organization} = user;

  return (
    <>
      {isOpen && (
        <ClickAwayListener onClickAway={onClose}>
          <Paper sx={styles.container}>
            <Stack
              direction="column"
              spacing={1}
              sx={{
                p: 1,
                alignItems: 'center',
                justifyContent: 'center',
                width: '100%',
                bgcolor: 'common.white',
              }}
            >
              <Stack direction="column" sx={{alignItems: 'center'}}>
                <Box
                  component="img"
                  src={`/images/logos/${organization.toLowerCase()}.jpg`}
                  alt={t('user.organization')}
                  sx={{height: 40, objectFit: 'cover', ml: 1, mb: 1}}
                />
              </Stack>
            </Stack>
            <Divider orientation="vertical" />
            <Stack direction="row" sx={{alignItems: 'flex-start', m: 1}}>
              <Stack direction="column" spacing={1} sx={{alignItems: 'flex-start', m: 1}}>
                <LabelChip value={`${firstName} ${lastName}`} icon={PersonIcon} />
                <LabelChip value={email} icon={EmailIcon} />
              </Stack>
            </Stack>
            <Stack direction="row" sx={{alignItems: 'flex-start', m: 1}}>
              <Stack direction="column" spacing={1} sx={{alignItems: 'flex-start', m: 1}}>
                <LabelChip value={username} icon={AlternateEmailOutlinedIcon} />
                <Button sx={styles.logout} onClick={onLogout} startIcon={<LogoutIcon />}>
                  {t('logout')}
                </Button>
              </Stack>
            </Stack>
          </Paper>
        </ClickAwayListener>
      )}
    </>
  );
};
export default ProfilePanel;

const styles: Record<string, SxProps> = {
  container: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    width: 'auto',
  },
  username: {
    color: primaryColor,
    border: `2px solid ${primaryColor}`,
    p: 1,
  },
  logout: {
    color: primaryColor,
    fontWeight: 700,
  },
  icon: {
    color: 'grey.700',
  },
  text: {
    color: 'grey.700',
  },
  profileButton: {
    m: 0,
    p: 0,
    height: '64px',
    bgcolor: 'common.white',
    '&:hover': {
      bgcolor: lighten(primaryColor, 0.75),
    },
  },
};
